import A11yDialog from 'a11y-dialog';
import Cookies from 'js-cookie';
import isbot from 'isbot';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dialog-container').forEach(el => {

    const noticeId = el.getAttribute('id');
    const expiresHours = el.getAttribute('data-expires') ? parseFloat(el.getAttribute('data-expires')) : 2;
    const expiresDays = expiresHours / 24;
    const dialog = new A11yDialog(el, document.getElementById('main'));

    function init() {
      if (!isbot(navigator.userAgent)) {
        if (expiresDays && Cookies.get(noticeId) == undefined) {
          dialog.show();
          Cookies.set(noticeId, 1, { expires: expiresDays });
        }
      }
    }

    init();

    // Add any event handlers here...
    // See https://github.com/edenspiekermann/a11y-dialog#js-api
  });

  document.querySelectorAll('[data-controls-dialog]').forEach(el => {

    const dialogId = el.getAttribute('aria-controls');
    const dialogEl = document.querySelector('#' + dialogId);
    const dialog = new A11yDialog(dialogEl, document.getElementById('main'));

    el.addEventListener('click', (e) => {
      dialog.show();
    });

    dialog.on('hide', function (element, event) {
      const video = element.querySelector('iframe');
      // console.log(video);
      if (video) {
        var src = video.src;
        video.src = src;
      }
    })

  });
});
